export default "__VITE_ASSET__AXveVmz$__"